/**
 * Created by lk on 17/6/4.
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;

// 权限管理

// 获取列表
export function MenuManagementList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/menu/show",
        method: "post",
        data: querys
    });
}

// 保存
export function MenuManagementSave(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/menu/add",
        method: "post",
        data: querys
    });
}

// 删除
export function MenuManagementDelete(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/menu/delete",
        method: "post",
        data: querys
    });
}
